import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchBar from './SearchBar'; // Import the new SearchBar
import './main.css'; // Assuming styles are here
import Logo from "./logo.webp"
// Receive products and potentially user info/code as props
const Header = ({ products = [] /*, loggedInCustomerCode */ }) => {
  const navigate = useNavigate();

  const handleCacheRefreshClick = (event) => {
    event.preventDefault();

    try {
        localStorage.clear();
        window.location.reload();

        
    } catch (error) {
      console.error("Error clearing local storage:", error);
      alert("Could not clear local storage. Please check browser settings or console for errors.");
    }
  };

  const navigateToSection = (sectionId) => {
    // Navigate to home page first
    navigate('/');
    
    // After navigation, scroll to the section
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      {/* Top Bar (Keep if needed globally) */}
      <div className="tophead">
        <div className="center">
          These prices are subject to a minimum quantity, for personal requirements please visit <a href="https://amcouch.com/" target="_blank" rel="noopener noreferrer">amcouch.com</a>
        </div>
      </div>

      {/* Main Header */}
      <header className="header main-header"> {/* Add class for potential sticky styling */}
        <input type="checkbox" name="" id="toggler" />
        <label htmlFor="toggler" className="fas fa-bars"></label>

        {/* Logo links to homepage */}
        <Link to="/" className="logo">
          Amcouch<span> by Amco industries</span><span>.</span>
        </Link>

        {/* Navbar with simplified links */}
        <nav className="navbar">
          <Link to="/">Home</Link>
          {/* Link to section on homepage, might need adjustment if not always landing page */}
          <a href="/#trending" onClick={(e) => {e.preventDefault(); navigateToSection('trending');}}>Trending</a>
          <Link to="/products">Products</Link>
          <a href="/#Categories" onClick={(e) => {e.preventDefault(); navigateToSection('Categories');}}>Categories</a>
          <a href="/#about" onClick={(e) => {e.preventDefault(); navigateToSection('about');}}>About</a>
          <a href="/#contact" onClick={(e) => {e.preventDefault(); navigateToSection('contact');}}>Contact</a>
        </nav>


        <div className="icons">
          <a href="/products" className="fas fa-shopping-cart" title="Shopping Cart (Placeholder)"></a>
          {/* the gear icon should empty out the local storage for the user of the site. the local storage currently has the customer code. */}
          <a href="#" className="fas fa-gear" onClick={handleCacheRefreshClick}  title="Cache Refresh"></a>
          <a href="/#contact" className="fas fa-phone" title="Phone (Placeholder)" onClick={(e) => {e.preventDefault(); navigateToSection('contact');}}></a>
          {/* Display logged-in code? */}
        </div>
      </header>
    </>
  );
};

export default Header;